module.exports = __webpack_public_path__ + "img/atlaslist3img4.c12bc711.jpg";